import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const PortareDietroButton = () => {
  const rootStore = useContext(RootStoreContext);
  const { theme } = rootStore.commonStore;
  const { ZwibblerUseMoveBack, isPickEnabled } = rootStore.zwibblerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    ZwibblerUseMoveBack();
  };

  return (
    <>
      <Button
        id="dietro"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 toolbarButton transparentButton",
          `${theme!.toolbarIconColor}`
        )}
        disabled={!isPickEnabled}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i className="fas fa-send-backward iconToolbarButton"></i>

        <h6 className="textToolbarButton mb-0">
          {t("toolbar_move_back_button")}
        </h6>
      </Button>
    </>
  );
};

export default observer(PortareDietroButton);
